import { createSlice } from '@reduxjs/toolkit';
import { OrganizationModel } from '../models/organization/organization';
import { setOrganizationId } from '../utilities/LocalStorage';
import _ from 'lodash';

interface OrganizationState {
  organization: OrganizationModel | null;
  organizations: OrganizationModel[] | null;
}

export const organizationSlice = createSlice({
  name: 'organizationSelector',
  initialState: {
    organization: null,
    organizations: null,
  } as OrganizationState,
  reducers: {
    setOrganization: (state, action) => {
      state.organization = action.payload;
      if (state.organization && state.organization.id) {
        setOrganizationId(state.organization.id);
      }
    },
    setOrganizations: (state, action) => {
      state.organizations = action.payload;
    },
    addOrganization: (state, action) => {
      state.organization = action.payload;
      if (state.organization && state.organization.id) {
        setOrganizationId(state.organization.id);
        state.organizations = _.orderBy([...(state.organizations || []), action.payload], (organization) => {
          return organization.name;
        });
      }
    },
  },
});

export const { setOrganization, setOrganizations } = organizationSlice.actions;

export default organizationSlice.reducer;
